import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { externalLayersKeys } from './queryKeys';
import type {
  ExternalLayer,
  UpdateExternalLayerBody,
} from 'hooks/externalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useUpdateExternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    ExternalLayer,
    undefined,
    { externalLayerId: UUID } & UpdateExternalLayerBody
  >({
    mutationFn: async ({ externalLayerId, ...patch }) => {
      const resp = await axios.patch<ExternalLayer>(
        `${config.apiGateway.external_layers}/${externalLayerId}`,
        patch
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('External layer updated.');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: externalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
